import { assets } from '../data/assets'
import { heroImageSizes, heroImageWidths, resizedImage, resizedSrcSet } from './image'

const FONT_URL =
  'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;1,700&family=Inter:wght@400;500;600;700&display=swap'

function addLink(attrs: Record<string, string>) {
  const link = document.createElement('link')
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v))
  document.head.appendChild(link)
  return link
}

// Runs before React renders: starts the hero image download immediately and
// loads fonts without blocking the first paint (fallback fonts are size-matched).
export function applyResourceHints() {
  document.documentElement.lang = 'es'

  addLink({
    rel: 'preload',
    as: 'image',
    href: resizedImage(assets.heroMockup, 380),
    imagesrcset: resizedSrcSet(assets.heroMockup, heroImageWidths),
    imagesizes: heroImageSizes,
    fetchpriority: 'high',
  })

  const fonts = addLink({ rel: 'stylesheet', href: FONT_URL, media: 'print' })
  fonts.onload = () => {
    fonts.media = 'all'
  }
}
